import MailSendSetting from './MailSendSetting'

export default MailSendSetting;